<template>
  <v-list-item class="border mx-4" height="45px" :style="{ 'background-color': '#f7f7f7' }">
    <v-row no-gutters class="justify-center align-center">
      <v-col cols="5" class="px-5">
        <v-list-item-content>
          <v-list-item-title class="text-left">
            <v-tooltip bottom color="font">
              <template #activator="{ on }">
                <div class="text-truncate font-weight-regular" v-on="on">
                  {{ verbose_name }}
                </div>
              </template>
              {{ verbose_name }}
            </v-tooltip>
          </v-list-item-title>
        </v-list-item-content>
      </v-col>
      <v-col cols="7">
        <v-row no-gutters class="justify-center align-center">
          <v-col cols="6">
            <v-row class="justify-center" no-gutters>
              <v-col cols="auto">
                <div :style="{ width: '150px' }">
                  <permissions-select-users
                    v-bind="$props"
                    :id="$props.module_name"
                    valueKey="main_value"
                    @update:value="mainValue = $event"
                  />
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6">
            <v-row v-if="attachments_and_comments" class="justify-center" no-gutters>
              <v-col cols="auto">
                <permissions-checkbox-users
                  v-bind="$props"
                  :id="$props.module_name"
                  valueKey="attachments_and_comments_value"
                  :disabled="isCommentsCheckboxDisabled"
                ></permissions-checkbox-users>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-list-item>
</template>

<script>
import PermissionsSelectUsers from '@/components/PermissionsSelectUsers';
import PermissionsCheckboxUsers from '@/components/PermissionsCheckboxUsers';

export default {
  name: 'UserGroupsPermissionsDialogToolsItem',
  components: {
    PermissionsSelectUsers,
    PermissionsCheckboxUsers,
  },
  props: {
    group: {
      type: String,
      required: true,
    },
    attachments_and_comments: {
      type: Boolean,
      required: true,
    },
    verbose_name: {
      type: String,
      required: true,
    },
    module_name: {
      type: [Number, String],
      required: true,
    },
    permission_type: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    mainValue: undefined,
  }),
  computed: {
    isCommentsCheckboxDisabled() {
      return this.mainValue == '0';
    },
  },
};
</script>

<style lang="scss" scoped>
.border {
  @include border(top);
  @include border(left);
  @include border(right);
  &:last-child {
    @include border(bottom);
  }
}
</style>
